/**
 * PageInfo directive displays pageTitleIcon and pageTitle
 * if this directive is too not flexible enough feel free to use markup from app/directives/cfnPageInfo directly
 */
angular.module('cfn').directive('cfnPageInfo', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      pageTitleIcon: '@icon'
    },
    transclude: true,
    templateUrl: require('./cfnPageInfo.html')
  };
});
